try {
  window.$ = window.jQuery = require('jquery');
} catch (e) {}

require('jquery-validation');

if ($('#home').length) {
  require('./scripts/home');
}

if ($('#questions').length) {
  require('./scripts/questions');
}

$(function () {

  const scrollBtn = $('.scroll_move');

  if (window.location.hash === '#banner') {
    history.replaceState(null, null, window.location.href.split('#')[0]);
    $('html, body').animate({
      scrollTop: $('#banner').offset().top - 82
    }, 1000);
  } else if (window.location.hash === '#ficha') {
    history.replaceState(null, null, window.location.href.split('#')[0]);
    $('html, body').animate({
      scrollTop: $('#ficha').offset().top - 82
    }, 1000);
  } else if (window.location.hash === '#home') {
    history.replaceState(null, null, window.location.href.split('#')[0]);
    $('html, body').animate({
      scrollTop: $('#home').offset().top - 82
    }, 1000);
  }

  const animeScrollBtn = () => {
    scrollBtn.on('click', () => {
        $('html,body').animate({
            scrollTop: $('.unacem_prom').offset().top
        }, 'slow');
    });
  }

  $('.scroll-link').on('click', function(event) {
    // Previene el comportamiento por defecto del enlace
    event.preventDefault();

    // Si el enlace no tiene la clase "disabled"
    if (!$(this).hasClass('disabled')) {
      // Obtiene el valor del atributo "href" del enlace
      var href = $(this).attr('href');

      // Desplaza el scroll hasta la posición del elemento con el ID indicado
      $('html, body').animate({
        scrollTop: $(href).offset().top - 82
      }, 1000);
    }
  });

  $('.menu_open').on('click', (e) => {
    e.preventDefault();
    $('.mobile').fadeIn();
    $('body').css('overflow', 'hidden');
    $('.menu_open').hide();
    $('.menu_close').show();
  });
  $('.menu_close').on('click', (e) => {
    e.preventDefault();
    $('.mobile').fadeOut();
    $('body').css('overflow', 'initial');
    $('.menu_close').hide();
    $('.menu_open').show();
  });

  $('.video_play').on('click', (e) => {
    const widthVideoPlay = $('.video_play').width();
    const heightVideoPlay = $('.video_play').height();
    const iframeVideo = $('#videoReproduce');

    $('.video_reproduce').width(widthVideoPlay);
    $('.video_reproduce').height(heightVideoPlay);

    $('.video_play').hide();
    $('.video_reproduce').show();

    $("#videoReproduce")[0].src += "&autoplay=1";
    e.preventDefault();

  });

  animeScrollBtn();
});
